import React from 'react';
import BrandingPanel from '../components/BrandingPanel';
import AllStudents from '../components/AllStudents';

const AllStudentsPage: React.FC = () => (
  <div style={{ display: 'flex', minHeight: '100vh', width: '100vw' }}>
    <BrandingPanel />
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
      <AllStudents />
    </div>
  </div>
);

export default AllStudentsPage;